function InputSelectModFijos({ value, setValue, label }) {

    return (
        <div className="form-group">
            <label>{label}</label>
            <select
                className="input"
                value={value || ""}
                onChange={(e) => setValue(e.target.value)}
            >
                <option value="" disabled>
                    Seleccione una opción
                </option>
                <option value="autenticacion">Autenticación</option>
                <option value="control">Control</option>
                <option value="solicitudes">Solicitudes</option>
                <option value="hardware">Hardware</option>
                <option value="red">Red</option>
                <option value="software">Software</option>
            </select>
        </div>
    );
}

export default InputSelectModFijos;